import React from 'react';
import './TryAgainModal.css';

const TryAgainModal = ({
    isOpen,
    onCancel,
    onRetry,
    title = "Action Interrupted",
    message = "It looks like the wallet interaction was cancelled or failed. Would you like to try again?"
}) => {
    if (!isOpen) return null;

    return (
        <div 
            className="try-again-overlay"
            onClick={(e) => e.stopPropagation()}
        >
            <div 
                className="try-again-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="try-again-content">
                    <div className="try-again-icon-container">
                        <svg className="try-again-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <div className="try-again-text-container">
                        <h3 className="try-again-title">{title}</h3>
                        <p className="try-again-message">{message}</p>
                    </div>
                </div>

                <div className="try-again-footer">
                    <button 
                        onClick={onCancel}
                        className="try-again-btn btn-cancel"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={onRetry}
                        className="try-again-btn btn-retry"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TryAgainModal;
